import React from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  CircularProgress,
  Typography,
  Paper,
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'

import { CustomButton, CustomTable, ModalConfirmacao } from 'components'
import { FormAddAnaliseInterna } from './FormAddAnaliseInterna'
import { useStyles } from './FormAnalisesInternas.styles'
import { useFormAnalisesInternas } from './useFormAnalisesInternas'

export const FormAnalisesInternas = (props) => {
  const { exameNecroscopico, setHideNextButton, router } = props
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const {
    processandoAnalisesInternas,
    isFormAddAnaliseInternaAtivo,
    setIsFormAddAnaliseInternaAtivo,
    openFichaDeletarAnaliseInterna,
    idCadaver,
    analisesInternas,
    setAnalisesInternas,
    setProcessandoAnalisesInternas,
    handleBotaoAdicionarAnaliseInterna,
    clickOpenModalDeletarAnaliseInterna,
    handleCloseModalDeletarAnaliseInterna,
    handleDeletarAnaliseInterna,
  } = useFormAnalisesInternas({
    exameNecroscopico,
    setHideNextButton,
  })

  const columns = [
    {
      title: 'Incisão',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>{rowData.incisao}</Typography>
      ),
    },
    {
      title: 'Região',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>{rowData.regiao}</Typography>
      ),
    },
    {
      title: 'Observações',
      render: (rowData) =>
        rowData.observacoes?.map((observacao, idx) => (
          <Typography key={idx} className={classes.linhaTabela}>- {observacao}</Typography>
        )) || ' - ',
    },
  ]

  return (
    <div>
      {isFormAddAnaliseInternaAtivo ? (
        <FormAddAnaliseInterna
          idExame={exameNecroscopico.id}
          idCadaver={idCadaver}
          setAnalisesInternas={setAnalisesInternas}
          router={router}
          setIsFormAddAnaliseInternaAtivo={setIsFormAddAnaliseInternaAtivo}
          setProcessando={setProcessandoAnalisesInternas}
          processando={processandoAnalisesInternas}
        />
      ) : (
        <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
          <Grid
            alignItems="flex-end"
            container
            justify="flex-end"
            spacing={3}
            className={classes.cabecalhoBotao}
          >
            <Grid item xs={12} sm="auto">
              <CustomButton
                color="primary"
                variant="contained"
                onClick={handleBotaoAdicionarAnaliseInterna}
              >
                <AddIcon className={classes.addIcon} />
                Adicionar Análise Interna
              </CustomButton>
            </Grid>
          </Grid>
          <Grid
            className={classes.dados}
            alignItems="center"
            container
            justify="space-between"
            spacing={1}
          >
            <Grid item md={12} sm={12} xs={12} className={classes.tableContainer}>
              {isMobile ? (
                analisesInternas && analisesInternas.length > 0 ? (
                  <Grid container spacing={2}>
                    {analisesInternas.map((item, index) => (
                      <Grid item xs={12} key={item.id || index}>
                        <Paper className={classes.analiseCard}>
                          <Box display="flex" justifyContent="space-between" alignItems="start" mb={1.5}>
                            <Typography
                              variant="subtitle2"
                              color="secondary"
                              style={{ fontWeight: 'bold', fontSize: '14px' }}
                            >
                              Análise {index + 1}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={() => clickOpenModalDeletarAnaliseInterna(item)}
                              style={{ padding: 4 }}
                            >
                              <DeleteIcon color="error" fontSize="small" />
                            </IconButton>
                          </Box>
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <Typography variant="body2" style={{ fontSize: '12px' }}>
                                <b>Incisão:</b> {item.incisao}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography variant="body2" style={{ fontSize: '12px' }}>
                                <b>Região:</b> {item.regiao}
                              </Typography>
                            </Grid>
                            {item.observacoes && item.observacoes.length > 0 && (
                              <Grid item xs={12}>
                                <Box mt={0.5}>
                                  <Typography variant="body2" style={{ fontSize: '12px' }}>
                                    <b>Observações:</b>
                                  </Typography>
                                  {item.observacoes.map((obs, idx) => (
                                    <Typography key={idx} variant="body2" style={{ fontSize: '12px', paddingLeft: 8 }}>
                                      - {obs}
                                    </Typography>
                                  ))}
                                </Box>
                              </Grid>
                            )}
                          </Grid>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Typography
                    style={{
                      fontSize: '12px',
                      padding: '24px',
                      textAlign: 'center',
                      color: '#999',
                      fontStyle: 'italic',
                    }}
                  >
                    Nenhuma análise interna registrada
                  </Typography>
                )
              ) : (
                <CustomTable
                  title=""
                  columns={columns}
                  data={analisesInternas || []}
                  isLoading={processandoAnalisesInternas}
                  emptyDataSourceMessage="Nenhuma análise interna registrada"
                  options={{
                    search: false,
                    pageSize: 6,
                    paging: false,
                    headerStyle: {
                      backgroundColor: '#f4f6f8',
                      fontSize: '12px',
                    },
                    toolbar: false,
                  }}
                  actions={[
                    {
                      icon: () => <DeleteIcon />,
                      tooltip: 'Deletar Item',
                      onClick: (event, rowData) => clickOpenModalDeletarAnaliseInterna(rowData),
                    },
                  ]}
                />
              )}
            </Grid>
          </Grid>

          <ModalConfirmacao
            aberto={openFichaDeletarAnaliseInterna}
            onClose={handleCloseModalDeletarAnaliseInterna}
            onConfirm={handleDeletarAnaliseInterna}
            titulo="Confirmar exclusão"
            confirmarColor="error"
            confirmarLabel="Confirmar Exclusão"
            processando={processandoAnalisesInternas}
          >
            Tem certeza que deseja deletar esta análise interna? Esta ação não pode ser desfeita.
          </ModalConfirmacao>
        </Grid>
      )}
    </div>
  )
}

FormAnalisesInternas.propTypes = {
  exameNecroscopico: PropTypes.object.isRequired,
  setHideNextButton: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
}
